<template>
  <v-container>
    <v-row>
      <v-col
        v-for="courier in mapCouriers"
        :key="courier.id_cliente"
        cols="12"
        md="4"
      >
        <v-card>
          <v-img :src="courier.logo2" height="200px"></v-img>
          <v-card-title>{{ courier.nombre }}</v-card-title>
          <v-card-subtitle>{{ courier.estado }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CouriersList",
  computed: {
    ...mapGetters(["mapCouriers"]),
  },
  methods: {
    listarCouriers() {
      this.$store.dispatch("listarCouriers");
    },
  },
  created() {
    this.listarCouriers();
  },
};
</script>

<style scoped>
/* Tu estilo aquí */
</style>
